module.exports = __webpack_public_path__ + "img/png_tszp_1@2x.bdc591f4.png";